
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name:"timetransform"})
export class TimeConterver implements PipeTransform {
    transform(seconds: number) {
        
      let  finalOutput = '';
      
        var days     = Math.floor(seconds / (24*60*60));
        seconds -= days    * (24*60*60);
    var hours    = Math.floor(seconds / (60*60));
        seconds -= hours   * (60*60);
    var minutes  = Math.floor(seconds / (60));
        seconds -= minutes * (60);
      
if(0<days){
    finalOutput += days+" Day "
}
if(0<hours){
    finalOutput += hours+" Hours "
}   
if(0<minutes){
    finalOutput += minutes+" Minutes "
}
if(0< seconds){
    finalOutput += seconds+" Seconds "
}else{
    finalOutput += 0+" Seconds "
}
    
    return finalOutput;

    }
}


// WEBPACK FOOTER //
// ./src/modals/orderdelivered/time-converter/time-converter.ts